export default __webpack_public_path__ + "static/media/amir-yaakobi.2ca7d7d8.png";